<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    class="navbar-left"
    v-model="isShowDrawer"
    v-click-outside.stop="closeDrawer"
    clipped
  >
    <template v-slot:img>
      <v-img height="100%" src="@/assets/img/sidebar.png" gradient="to top right, rgba(0,7,71,.8), rgba(5,80,166,.9)"></v-img>
    </template>
    <v-list dense dark nav>
      <v-list-item-group>
        <v-divider class="divider--top"></v-divider>
        <v-list-item disabled>
          <v-list-item-avatar>
            <v-icon
              class="grey lighten-1 white--text"
            >mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="mainName"></v-list-item-title>
            <v-list-item-subtitle v-text="subName"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="divider--bottom"></v-divider>
        <template v-for="item in items[$store.state.user.role]">
          <v-list-item
            :key="item.text"
            v-if="!item.disabled"
            active-class="secondary"
            :to="item.to"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="list-title">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>

          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
export default {
  name: "VNavbarLeft",

  data() {
    return {
      isShowDrawer: false,
      items: {
        Teacher: [
          { icon: "mdi-home", text: "トップページ", disabled: false, to: "/teacher/home" },
          { icon: "mdi-content-save-edit-outline", text: "問題作成", disabled: false, to: "/teacher/create_print" },
          { icon: "mdi-cloud-print", text: "保存問題", disabled: this.$store.getters['user/isSampleAccount'], to: "/teacher/saved_prints" },
          {
            icon: "mdi-cog",
            text: "設定",
            disabled: false,
            to: "/teacher/setting",
          },
          { icon: "mdi-logout", text: "ログアウト", disabled: false, to: "/sign_in" },
        ],
        Admin: [
          { icon: "mdi-email-multiple-outline", text: "申し込み一覧", disabled: false,  to: "/admin/home" },
          { icon: "mdi-school", text: "塾一覧", disabled: false,  to: "/admin/schools" },
          { icon: "mdi-book-open-outline", text: "請求CSV", disabled: false,  to: "/admin/invoice_csv" },
          { icon: "mdi-bell", text: "お知らせ", disabled: false,  to: "/admin/notifications" },
          { icon: "mdi-logout", text: "ログアウト", disabled: false,  to: "/admin/sign_in" },
        ],
      },
    }
  },

  watch: {
    drawer(now) {
      this.isShowDrawer = now;
    }
  },

  methods: {
    closeDrawer(event) {
      // ipadのではmenuaアイコンクリック時に処理を行わない。
      if (event.target.className.includes('menu-icon__bars') || event.target.className.includes('menu-icon')) return
      if (this.drawer) this.$store.commit('setDrawer', { drawer: !this.drawer })
    }
  },

  computed: {
    drawer() {
      return this.$store.state.drawer;
    },
    mainName() {
      switch(this.$store.state.user.role) {
        case 'Admin':
          return 'ゲットスルー2600';
        case 'Teacher':
          return this.$store.state.user.customerName;
        default:
          return ''
      }
    },
    subName() {
      switch(this.$store.state.user.role) {
        case 'Admin':
          return 'システム管理者';
        case 'Teacher':
          return this.$store.state.user.classroomName;
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="stylus">
.navbar-left
  position fixed
  z-index 1

.divider--top
  border-color #6790c0 !important

.divider--bottom
  border-color #6790c0 !important
  margin-bottom 5px

</style>
